export enum TopPerformingTabs {
    TopMessages = 'top_messages',
    TopLabels = 'top_labels',
}
